/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { RqthRefusalReasonResource } from './';
import {
    RqthRefusalReasonResourceFromJSON,
    RqthRefusalReasonResourceFromJSONTyped,
    RqthRefusalReasonResourceToJSON,
} from './';
import type { RqthReviewStatusResource } from './';
import {
    RqthReviewStatusResourceFromJSON,
    RqthReviewStatusResourceFromJSONTyped,
    RqthReviewStatusResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface RqthDeclarationResource
 */
export interface RqthDeclarationResource {
    /**
     * 
     * @type {string}
     * @memberof RqthDeclarationResource
     */
    id: string;
    /**
     * 
     * @type {RqthReviewStatusResource}
     * @memberof RqthDeclarationResource
     */
    reviewStatus: RqthReviewStatusResource;
    /**
     * 
     * @type {RqthRefusalReasonResource}
     * @memberof RqthDeclarationResource
     */
    refusalReason?: RqthRefusalReasonResource;
    /**
     * 
     * @type {Date}
     * @memberof RqthDeclarationResource
     */
    expiryDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof RqthDeclarationResource
     */
    fileName?: string;
    /**
     * Date and time at which the declaration's file was uploaded.
     * @type {Date}
     * @memberof RqthDeclarationResource
     */
    uploadedDate?: Date;
    /**
     * Link to download the declaration's file. Null when no file is available.
     * @type {string}
     * @memberof RqthDeclarationResource
     */
    downloadLink?: string;
    /**
     * The freelancer's profile ID, used to build the link to their public profile page.
     * @type {string}
     * @memberof RqthDeclarationResource
     */
    profileId?: string;
}

/**
 * Check if a given object implements the RqthDeclarationResource interface.
 */
export function instanceOfRqthDeclarationResource(value: object): value is RqthDeclarationResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('reviewStatus' in value) || value['reviewStatus'] === undefined) return false;
    return true;
}

export function RqthDeclarationResourceFromJSON(json: any): RqthDeclarationResource {
    return RqthDeclarationResourceFromJSONTyped(json, false);
}

export function RqthDeclarationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): RqthDeclarationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'reviewStatus': RqthReviewStatusResourceFromJSON(json['reviewStatus']),
        'refusalReason': json['refusalReason'] == null ? undefined : RqthRefusalReasonResourceFromJSON(json['refusalReason']),
        'expiryDate': json['expiryDate'] == null ? undefined : (new Date(json['expiryDate'])),
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'uploadedDate': json['uploadedDate'] == null ? undefined : (new Date(json['uploadedDate'])),
        'downloadLink': json['downloadLink'] == null ? undefined : json['downloadLink'],
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
    };
}

export function RqthDeclarationResourceToJSON(value?: RqthDeclarationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'reviewStatus': RqthReviewStatusResourceToJSON(value['reviewStatus']),
        'refusalReason': RqthRefusalReasonResourceToJSON(value['refusalReason']),
        'expiryDate': value['expiryDate'] == null ? undefined : ((value['expiryDate'] as any).toISOString().substring(0,10)),
        'fileName': value['fileName'],
        'uploadedDate': value['uploadedDate'] == null ? undefined : ((value['uploadedDate'] as any).toISOString()),
        'downloadLink': value['downloadLink'],
        'profileId': value['profileId'],
    };
}

